export { default } from "./HorizontalMenu";
